import React from "react";
import PropTypes from "prop-types";

// Shared tooltip renderer used by every chart variant so the visual style and
// number formatting stay consistent across the dashboard.
const ChartTooltip = ({ active, payload, label, valueFormatter }) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const format = valueFormatter || ((value) => value);

  return (
    <div className="app-chart__tooltip" role="tooltip">
      {label !== undefined && label !== null && (
        <div className="app-chart__tooltip-label">{label}</div>
      )}
      {payload.map((entry) => (
        <div
          className="app-chart__tooltip-row"
          key={`${entry.dataKey}-${entry.name}`}
        >
          <span
            className="app-chart__tooltip-swatch"
            style={{ backgroundColor: entry.color || entry.fill }}
          />
          <span>{entry.name}:</span>
          <strong>{format(entry.value, entry)}</strong>
        </div>
      ))}
    </div>
  );
};

ChartTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueFormatter: PropTypes.func,
};

export default ChartTooltip;
